import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalComponent } from './modal.component';
import {CardModule} from '../card/card.module';

@NgModule({
  imports: [
    CommonModule,
    CardModule,
  ],
  declarations: [ModalComponent],
  exports: [ModalComponent]
})
export class ModalModule { }
